import router from './router'
import { isTokensNotEmpty } from '@/utils/auth'
import { getLocalStorage } from '@/utils/locatonStorge'

router.beforeEach(async (to, from, next) => {
  const isLoginStatus = isTokensNotEmpty()
  // TODO: 接口判断网站是否挂了 isAbnormal
  const isAbnormal = false
  if (isAbnormal && to.path !== '/sysupgrade') {
    next({
      path: '/sysupgrade'
    })
  }
  if (isLoginStatus) {
    // if (to.path === '/' || to.path.toLowerCase().startsWith('/detail')) {
    //   $('html, body').css({ overflow: 'hidden' })
    // } else {
    //   $('html, body').css({ overflow: 'auto' })
    // }
    const currentChatVersion = getLocalStorage('chatTools')

    console.log('isLoginStatus', isLoginStatus, to.path)
    if (to.path.toLowerCase().startsWith('/login')) {
      // 如果已登录，跳转到首页
      next({
        path: '/'
      })
    } else if (currentChatVersion === 'glm-4' && to.path === '/') {
      return next({ name: 'alltoolsdetail' })
    } else {
      next()
    }
  } else {
    next()
  }
})
